import * as React from 'react';
export const IcPests = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.89 14.55l-.62-1.26a3.002 3.002 0 00-1.74-1.5L17 11.28v-.56l1-.32a3 3 0 002-2.84V6a1 1 0 00-2 0v1.56a1 1 0 01-.68 1l-.76.25A2 2 0 0015 8a3 3 0 00-.69-1.89l1.4-1.4a1.004 1.004 0 00-1.42-1.42l-1.76 1.76a2.83 2.83 0 00-1.06 0L9.71 3.29a1.004 1.004 0 10-1.42 1.42l1.4 1.4A3 3 0 009 8a2 2 0 00-1.56.76l-.76-.25a1 1 0 01-.68-1V6a1 1 0 10-2 0v1.56a3 3 0 002.05 2.84l1 .32v.56l-1.53.51a3 3 0 00-1.74 1.5l-.62 1.26a1 1 0 00.44 1.34c.123.066.26.104.4.11a1 1 0 00.89-.55l.63-1.26a1 1 0 01.58-.5l.9-.3V15a5 5 0 00.19 1.29l-1 .52a3 3 0 00-1.34 1.34l-.7 1.4a1 1 0 00.44 1.34A.929.929 0 005 21a1 1 0 00.89-.55L6.6 19a.94.94 0 01.4-.4l1-.52a4.94 4.94 0 007.82 0l1.18.52a.94.94 0 01.44.44l.71 1.41A1 1 0 0019 21a.929.929 0 00.45-.11 1 1 0 00.44-1.34l-.7-1.4a3 3 0 00-1.34-1.34l-1-.52c.106-.422.156-.855.15-1.29v-1.61l.9.3a1 1 0 01.58.5l.63 1.26A1 1 0 0020 16a.929.929 0 00.45-.11 1 1 0 00.44-1.34z'
      fill='currentColor'
    />
  </svg>
);
